var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-landing-page-container" }, [
    _vm.imageUrl
      ? _c("div", {
          staticClass: "trbo-a-header-image",
          style: { "background-image": "url(" + _vm.imageUrl + ")" },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-panel" }, [
      _c("div", { staticClass: "trbo-a-panel-title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "trbo-a-panel-description",
        domProps: { innerHTML: _vm._s(_vm.sanitizedDescription) },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "trbo-a-panel-button",
          on: {
            click: function ($event) {
              return _vm.onClickStart()
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "trbo-a-panel-button-arrow-icon",
              attrs: {
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 16H27",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M18 7L27 16L18 25",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
          _vm._v("\n      " + _vm._s(_vm.buttonTitle) + "\n    "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }